<template>
  <div v-if="releaseOverview != null">
    <table>
      <thead>
        <tr>
          <th></th>
          <th>Consultant Name</th>
          <th>Booking Node</th>
          <th>Position</th>
          <th>DateOfBooking</th>
          <th>Description</th>
          <th>Total Time</th>
          <th>From</th>
          <th>To</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in releaseOverview" :key="user.EmployeeId">
          <td><input type="checkbox" v-model="user.checked"></td>
          <td>{{ user.EmployeeFirsName +" "+ user.EmployeeLastName}}</td>
          <td>{{ user.ProjectTitle }}</td>
          <td>{{ user.PositionTitle }}</td>
          <td>{{ user.DateOfBooking | date('YYYY-MM-DD')}}</td>
          <td>{{ user.Description }}</td>
          <td>{{ user.TimeUsed }}</td>
          <td>{{ user.FromTime }}</td>
          <td>{{ user.ToTime }}</td>
        </tr>
      </tbody>
    </table>
    <br>
    <div class="cta_btn-wrapper">
      <button class="cta-btn" @click="confirmAction('approve')" :disabled="!atLeastOneSelected">Approve Selected</button>
      <button class="cta-btn"  @click="confirmAction('reject')" :disabled="!atLeastOneSelected">Reject Selected</button>
      <button class="cta-btn" @click="confirmAction('approveAll')">Approve All</button>
      <button class="cta-btn" @click="confirmAction('rejectAll')">Reject All</button>
    </div>
   
  </div>
</template>

<script>
import url from "../../../../config/url";
import moment from 'moment';
export default {
  name: 'ReleaseOverviewTable',
  props: {
    releaseOverview: {
      required: true
    }
  },
  filters: {
    date(value) {
      if (value) {
        return moment(String(value)).format('YYYY-MM-DD');
      }
    }
  },
  computed: {
    atLeastOneSelected() {
      return this.releaseOverview.some((user) => user.checked)
    },
		token: function () {
			return this.$store.state.auth.token;
		}
  },
  methods: {
    confirmAction(action) {
      let message = '';
      if (action === 'approve') {
        message = 'Are you sure you want to approve the selected items?';
      } else if (action === 'reject') {
        message = 'Are you sure you want to reject the selected items?';
      } else if (action === 'approveAll') {
        message = 'Are you sure you want to approve all items?';
      } else if (action === 'rejectAll') {
        message = 'Are you sure you want to reject all items?';
      }

      if (confirm(message)) {
        if (action === 'approve') {
          this.submitData('approve');
        } else if (action === 'reject') {
          this.submitData('reject');
        } else if (action === 'approveAll') {
          this.submitAllData('approve');
        } else if (action === 'rejectAll') {
          this.submitAllData('reject');
        }
      }
    },
    submitData(action) {
      const checkedUsers = this.releaseOverview.filter(user => user.checked)
      const data = JSON.stringify({
        action,
        users: checkedUsers
      })

      // Make an AJAX call to a C# backend with the data as JSON
      fetch(url.qtime_release_overview_submitdata, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization' : this.token
        },
        body: data
      })
      .then(response => {
        // Handle the response from the backend
        location.reload();
      })
      .catch(error => {
        // Handle any errors that occur during the AJAX call
      })
    },
    submitAllData(action) {
      const data = JSON.stringify({
        action: action,
        users: this.releaseOverview
      })

      // Make an AJAX call to a C# backend with the data as JSON
      fetch(url.qtime_release_overview_submitdata, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization' : this.token
        },
        body: data
      })
      .then(response => {
        // Handle the response from the backend
        location.reload();
      })
      .catch(error => {
        // Handle any errors that occur during the AJAX call
      })
    }
  }
}
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {

  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}
button.cta-btn[disabled="disabled"] {
  cursor: not-allowed;
  opacity: .5;
  background: transparent !important;
  color: #222 !important;
  }
  .cta_btn-wrapper, table td,table th {
		padding-left: 49px;
    white-space: nowrap;
		}

.comp-body-wrapper table th {
background: #f5f6f8;
color: #8f8f8f;
padding-top: 18.5px;
padding-bottom: 18.5px;
font-weight: 700;
}
.cta-btn{
  padding: 0.7rem 1.4rem !important;
}
@media only screen and (max-width: 768px) {
  .cta_btn-wrapper {
  margin: 10px 0 !important;
  }
  }
</style>